// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__fvUOK","col":"Table_col__2NyWm","fulfillmentStatus":"Table_fulfillmentStatus__1njiw","emailCol":"Table_emailCol__1YAeU"};